import React, { Fragment, useState } from 'react';
import cn from 'classnames';
// import { parse } from 'date-fns';
import { formatDate } from '../../common/utils/format';
import { ProjectApi } from '../../customer_project/api/project-api';
import SvgIcon from '../../common/SvgIcon';
// import project from '../../design/routes/Workdesk/api/project';
import workInProgressImg from './work_in_progress.jpg';
import onboardingImg from './onboarding.png';
import { isRoomStyling, isDesignFix } from '../../common/components/ProjectStatus/utils';

const PROJECT_ONBOARDING_STATUS = 'onboarding';
const PROJECT_ON_PAUSE_STATUS = 'on_pause';
const SHOPPING_SUPPORT_CALL_URL = 'https://meetings.hubspot.com/sian-mclernon';

const projectRedBorder = project =>
  project.status === PROJECT_ONBOARDING_STATUS || project.status === PROJECT_ON_PAUSE_STATUS;

const projectName = project => `${project.headline || project.name}`;

const projectArchivedForCustomer = project => project.status === 'archived';

const categoryReleasedForCustomer = project =>
  project.category_release_status === 'approved' && project.status === 'in_progress';

const projectInProgress = project =>
  project.status === 'in_progress' || project.status === 'awaiting' || project.status === 'sent_to_review';

const projectOnboarding = project => project.status === 'onboarding';

const isConsultancy = project => project.plan === 'consultancy';

const isRoomStylingProject = project => {
  return isRoomStyling(project.room_type);
};

const isDesignFixProject = project => {
  return isDesignFix(project.room_type);
};

const projectOnPause = project => project.status === 'on_pause';

const projectMoreTimeApproved = project => project.additional_hours_status === 'approved';

const projectRestartRequestDate = project => {
  if (!project.unpause_requested_at) return null;
  return formatDate(project.unpause_requested_at);
};

const projectMoreTimeRequestDate = project => {
  if (!project.additional_hours_requested_at) return null;
  return formatDate(project.additional_hours_requested_at);
};

const projectRestartRequested = project =>
  projectOnPause(project) && projectRestartRequestDate(project);

const projectMoreTimeRequested = project =>
  (projectArchived(project) || projectApproved(project)) && projectMoreTimeRequestDate(project);

const projectApproved = project => project.status === 'approved';
const projectArchived = project => project.status === 'archived';

const ProjectItem = ({ project: initProjects, proPlatform, hasShoppingCredits }) => {
  const [project, setProject] = useState(initProjects);
  const [actionInProgress, setActionInProgress] = useState(0);

  const roomStylingProject = isRoomStylingProject(project);
  const designFixProject = isDesignFixProject(project);
  function requestUnpauseOnClick() {
    setTimeout(() => setActionInProgress(actionInProgress + 1));
    ProjectApi.requestProjectRestart(
      project.id,
      response => {
        setTimeout(() => {
          setProject(response);
          setActionInProgress(actionInProgress - 1);
        }, 500);
        return response;
      },
      response => {
        alert('Sorry. Something went wrong.');
        setActionInProgress(actionInProgress - 1);
        return response;
      },
    );
  }

  function requestMoreTimeOnClick() {
    setTimeout(() => setActionInProgress(actionInProgress + 1));
    ProjectApi.requestProjectMoreTime(
      project.id,
      response => {
        setTimeout(() => {
          setProject(response);
          setActionInProgress(actionInProgress - 1);
        }, 500);
        return response;
      },
      response => {
        alert('Sorry. Something went wrong.');
        setActionInProgress(actionInProgress - 1);
        return response;
      },
    );
  }

  const renderProjectCompleted = () => (
    <div className="image -fourxthree">
      {project.image && <img className="image_body" src={project.image.url} alt="" />}
    </div>
  );

  const renderCategoryReleasedForCustomer = () => {
    const { image } = project;
    if (image && image.url) {
      return renderProjectCompleted();
    }
    return (
      <div className="image -fourxthree">
        <img className="image_body" src={workInProgressImg} alt=""/>
      </div>
    );
  };

  const renderProjectOnboarding = () => (
    <div className="image -fourxthree">
      <img className="image_body" src={onboardingImg} alt=""/>
    </div>
  );

  const renderProjectOnPause = () => (
    <div className="text-with-icon">
      <div className="text-with-icon_inner">
        <div className="status-icon -on-pause">
          <svg className="">
            <use xlinkHref="#project-on-pause" xmlnsXlink="http://www.w3.org/1999/xlink" />
          </svg>
        </div>
      </div>
    </div>
  );

  const renderProjectInProgress = () => (
    <div className="image -fourxthree">
      <img className="image_body" src={workInProgressImg} alt="" />
    </div>
    // <div className="text-with-icon">
    //   <div className="text-with-icon_inner">
    //     <div className="status-icon">
    //       <svg className="">
    //           <use xlinkHref="#project-in-progress" xmlnsXlink="http://www.w3.org/1999/xlink" />
    //         </svg>
    //       </div>
    //       {/* <span className="project-preview-text">Design in progress</span> */}
    //     </div>
    //   </div>
  );

  const renderConsultanyProgress = () => {
    const { image } = project;
    return (
      <Fragment>
        {image && (
          <div className="image -fourxthree">
            {<img className="image_body" src={project.image.url} alt="" />}
          </div>
        )}
        {!image && (
          <div className="image -fourxthree">
            <img className="image_body" src={workInProgressImg} alt=""/>
          </div>
        )}
      </Fragment>
    );
  };

  const renderProjectImage = () => {
    if (isConsultancy(project)) {
      return renderConsultanyProgress(project);
    }
    if (projectOnPause(project)) {
      return renderProjectOnPause(project);
    }
    if (projectApproved(project)) {
      return renderProjectCompleted(project);
    }
    if (projectArchivedForCustomer(project)) {
      return renderProjectCompleted(project);
    }
    if (categoryReleasedForCustomer(project)) {
      return renderCategoryReleasedForCustomer(project);
    }
    if (projectOnboarding(project)) {
      return renderProjectOnboarding(project);
    }
    return renderProjectInProgress(project);
  };

  const renderConsultancyStatusDescription = () => {
    if (projectInProgress(project)) {
      if (!proPlatform && projectMoreTimeApproved(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              <SvgIcon icon="icon-more-hours" />
              Your design is ready - let’s bring it to life.
            </div>
            <div>
              Benefit from our exclusive savings of up to 25%.
              Have questions? You can reach your shopping support team on the chat anytime, and for as long as you need.
            </div>
            <div>
              Hours bought: {project.hours_purchased} <br />
              Hours complete: {project.hours_used}
            </div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                MORE TIME ADDED WITH YOUR DESIGNER
              </button>
            </div>
          </div>
        );
      }
      if (!proPlatform && !project.designer_assigned) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">Brief complete - thank you!</div>
            <div>
              Our team will review the details and match you with a designer. We'll introduce you
              to your designer on the CHAT to start the design process.
            </div>
            <div>
              Hours bought: {project.hours_purchased} <br />
              Hours complete: {project.hours_used}
            </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">
            Design in progress
          </div>
          <div>
            <span>Check back soon to see how your space is coming together.</span>
            <br />
            <i>Your designer is actively working on creating a room you’ll love.</i>
          </div>
          <div>
            Hours bought: {project.hours_purchased} <br />
            Hours complete: {project.hours_used}
          </div>
        </div>
      );
    }

    if (projectOnPause(project)) {
      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">
            Your design is currently paused
          </div>
          <div>You can restart it anytime to continue where you left off.</div>
          <div>
            <i>
              Note: Changes to your brief may affect pricing.
            </i>
          </div>
          <div>
            Hours bought: {project.hours_purchased} <br />
            Hours complete: {project.hours_used}
          </div>
        </div>
      );
    }

    if (projectOnboarding(project)) {
      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Action required: please complete the design brief.
          </div>
          <div>We need some additional details to start the consultancy work.</div>
          <div className="project-preview_attention_button">
            <a href={project.link} className="btn -yellow">
              COMPLETE DESIGN BRIEF
            </a>
          </div>
        </div>
      );
    }

    if (projectApproved(project) || projectArchived(project)) {
      if (projectMoreTimeRequested(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">Consultancy complete!</div>
            <div>Your time has now come to an end with your designer.</div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                REQUEST SENT
              </button>
              <p>One of our team will be in touch shortly.</p>
            </div>
          </div>
        );
      }
      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">Consultancy complete!</div>
          <div>
            Your time has now come to an end with your designer. If you would like to buy more
            hours, please press the button below.
            <br />
            Hours bought: {project.hours_purchased} <br />
            Hours complete: {project.hours_used}
          </div>
          <div className="project-preview_attention_button">
            {!projectMoreTimeApproved(project) ? (
              <button
                onClick={() => requestMoreTimeOnClick()}
                type="button"
                className={cn('btn -yellow', { '-in-progress': actionInProgress })}
              >
                Buy more time with my designer
              </button>
            ) : null}
            {projectMoreTimeApproved(project) ? (
              <Fragment>
                <button type="button" className="btn -empty -with-icon">
                  <SvgIcon icon="icon-check" className="checkbox_icon" />
                  REQUEST SENT
                </button>
                <p>Thank you, one of our team will be in touch shortly.</p>
              </Fragment>
            ) : null}
          </div>
        </div>
      );
    }
    return null;
  };

  // The credits clause only appears for customers who actually hold credits -
  // expired ones included, same rule as the account menu tab.
  // Shown once the design is ready: shopping the design and booking a call with
  // the shopping support team, the same pair offered on the moodboard page.
  const renderDesignReadyActions = () => (
    <div className="project-preview_attention_button project-preview_attention_actions">
      <a href={project.link} className={cn('btn -yellow -in-progress')}>
        Shop My Design
      </a>
      <a
        href={SHOPPING_SUPPORT_CALL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn -empty project-preview_attention_actions_secondary"
      >
        <SvgIcon icon="icon-calendar" className="project-preview_attention_actions_icon" />
        Book Shopping Support Call
      </a>
    </div>
  );

  const projectReadySentance = () => {
    return hasShoppingCredits
      ? 'Shop your designer-curated pieces, use your shopping credits, enjoy exclusive savings and get shopping support whenever you need it.'
      : 'Shop your designer-curated pieces, enjoy exclusive savings and get shopping support whenever you need it.';
  };

  const renderDesignFixArchived = () => {
    return (
      <div className="project-preview_attention">
        <div className="project-preview_attention_title">
          Your design fix is ready...
        </div>
        <div className="project-preview_attention_button">
          <a href={project.link} className={cn('btn -yellow -in-progress')}>
            View Fix
          </a>
        </div>
      </div>
    );
  };

  const renderStatusDescription = () => {
    if (isConsultancy(project)) {
      return renderConsultancyStatusDescription(project);
    }

    if (projectOnboarding(project)) {
      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Complete your design brief.
          </div>
          <div>
            We just need a few more details about you and your space so we can kick off the design process and start creating something amazing!
          </div>
          <div className="project-preview_attention_button">
            <a href={project.link} className="btn -yellow">
              Complete Design Brief
            </a>
          </div>
        </div>
      );
    };

    if (categoryReleasedForCustomer(project)) {
      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Categories released and ready to shop!
          </div>
          <div>
            Your designer is working hard to create a room you'll love. Please continue to check in
            regularly to keep the design process moving.
          </div>
        </div>
      );
    };

    if (projectInProgress(project)) {
      if (!proPlatform && projectMoreTimeApproved(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              <SvgIcon icon="icon-more-hours" />
              Your design is ready - let’s bring it to life.
            </div>
            <div>
              {projectReadySentance()}
            </div>
            <div>
              Got questions? Your shopping support team is just a message away - anytime you need.
            </div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                MORE TIME ADDED WITH YOUR DESIGNER
              </button>
            </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Design in progress
          </div>
          <div>
            <span>Check back soon to see how your space is coming together.</span>
            <br />
            <i>Your designer is actively working on creating a room you’ll love.</i>
          </div>
        </div>
      );
    }
    if (projectOnPause(project)) {
      if (projectRestartRequested(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              <b>Design process on pause: request to restart project has been sent.</b>
              {/* <b> {formatDate(projectRestartRequestDate(project), FULL_HUMAN_DATE_FORMAT)} </b> */}
            </div>
            <div>Charges may apply if your brief has changed.</div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                Restart Requested
              </button>
              <p>One of our team will be in touch shortly.</p>
            </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Your design is currently paused
          </div>
          <div>You can restart it anytime to continue where you left off.</div>
          <div>
            <i>
            Note: Changes to your brief may affect pricing.
            </i>
          </div>
          <div className="project-preview_attention_button">
            <button
              onClick={() => requestUnpauseOnClick()}
              type="button"
              className={cn('btn -yellow', { '-in-progress': actionInProgress })}
            >
              Restart Project
            </button>
          </div>
        </div>
      );
    };

    if (projectApproved(project)) {
      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Your design is ready - let’s bring it to life.
          </div>
          {!proPlatform && (
            <Fragment>
              <div>
                {projectReadySentance()}
              </div>
              <div>
                Got questions? Your shopping support team is just a message away - anytime you need.
              </div>
              {!designFixProject && (
                <div>
                  Remember you have&nbsp;
                  <b>{project.days_before_archived} days</b> to ask your designer any questions
                </div>
              )}
              {renderDesignReadyActions()}
            </Fragment>
          )}
        </div>
      );
    };

    if (projectArchived(project)) {
      if (designFixProject) {
        return renderDesignFixArchived();
      } else {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              Your design is ready - let’s bring it to life.
            </div>
            {!proPlatform && (
              <Fragment>
                <div>
                  {projectReadySentance()}
                </div>
                <div>
                  Got questions? Your shopping support team is just a message away - anytime you need.
                </div>
                {renderDesignReadyActions()}
              </Fragment>
            )}
          </div>
        );
      }
    }
    return null;
  };

  const renderShareOptions = () => {
    if (!projectApproved(project) || proPlatform || isConsultancy(project)) return null;
    return (
      <div className="project-preview_attention">
        <div className="project-preview_attention_title">
          Share your design with family and friends
        </div>
        <div>
          Chuffed with your design and want to share it?
          Choose your method below and we'll create a copy to share!
          We'll even throw in a referral code for them to get 15% off their first room.
          When they book you'll also get 15% off you next room design!
        </div>
        <button type='button'>
          Copy link to design
        </button>
      </div>
    );
  };

  const renderProjectItem = () => (
    <div className={cn('customer-projects-list_item')}>
      <a href={project.link} className={cn('project-preview_image')}>
        <div className="project-preview_title -ontop text-center ">{projectName(project)}</div>
        <div
          className={cn('project-preview_photo-wrapper', {
            '-border-red': projectRedBorder(project),
          })}
        >
          {renderProjectImage(project)}
        </div>
        <div className="project-preview_title -under text-center">{projectName(project)}</div>
      </a>
      <div className="project-preview_info-wrapper">
        {renderStatusDescription(project)}
      </div>
    </div>
  );

  return renderProjectItem();
};

export default ProjectItem;



// WEBPACK FOOTER //
// ./app/javascript/components/customer_projects_list/project_item.js